

// //bootstrap styling
import "@tremor/react/dist/esm/tremor.css";
import "bootstrap/dist/css/bootstrap.min.css";


import React from "react";
import ReactDOM from "react-dom";
import { storeConfig } from "_redux";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import "./init";
const { store, persistor } = storeConfig();

import Router from "_navigations";

// css
import 'typeface-roboto';
import './global.css';

const App = () => {
  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <React.StrictMode>
          <Router />
        </React.StrictMode>
      </PersistGate>
    </Provider>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
